export const CalendarEN = {
    "calendar" : "Calendar" ,
    "calendar-cat" : "Company/Department calendar " ,
    "calendar-room" : "Meeting room " ,
    "addPersonalCalendar": "Add personal calendar" ,
    "createEvent": "Create a event"
}